
const selectors = {
	/**
	 * This is technically only needed temporarily to lazy-fetch longId and env
	 * in a resolver. Maybe there are better ways to deal with this?
	 */
	getExtensionData: (state) => state.extension,
	getLongId: (state) => state.longId,
	getEnv: (state) => state.env,
	getSdkVersion: (state) => state.sdkVersion,
	getSdkIntegrity: (state) => state.sdkIntegrity,
	getSdk: (state) => state.sdk,
	isHostedModeForced: (state) => state.forceHostedFlow,
	getIsValidForComponent: (state, componentName) => {

		/**
		 * For Stripe Connect, validity is applicable for all payment methods.
		 * But for Worldpay, older provider, validity is only applicable for 'cards', the rest methods
		 * we consider always valid. So if it is not set, we decide this is one of non-card Wordpay
		 * methods, which are always valid.
		 *
		 * It is not perfect: if we need validity status too early, it may be false-positive.
		 * But too early means before the component was dropped in, so this problem existed before.
		 * We should deal with it in another way.
		 */
		return state.isValid[componentName] ?? true;
	},
	getActivePaymentMethod: (state) => state.activePaymentMethod,
	getAvailableDropInComponents: (state) => state.availableDropInComponents,
	getOrderId: (state) => state.orderId,
	getOnPaymentDeclinedNonce: (state) => state.onPaymentDeclinedNonce,
};

export default selectors;
